export const saveRedirectPath = () => {
  if (typeof window !== "undefined") {
    const path = window.location.pathname + window.location.search;
    sessionStorage.setItem("redirectAfterLogin", path);
  }
}

export const getRedirectPath = () => {
  const path = sessionStorage.getItem("redirectAfterLogin");
  sessionStorage.removeItem("redirectAfterLogin");
  return path || "/"
}